<template>
  <v-card class="white rounded-lg">
    <v-card-title class="secondary--text">
      لیست کد های تخفیف
    </v-card-title>

    <v-card-text>
      <div>
        <m-datatable :show-filter-row="false" :headers="headers" :apiUrl="url" :filters.sync="filters" ref="datatable">
          <template #item.allowed_billing_cycles="{ item }">
            <div class="d-flex flex-wrap gap-1">
              <v-chip
                v-for="cycle in item.allowed_billing_cycles"
                :key="cycle"
                small
                color="primary"
                class="ma-1"
              >
                {{ getBillingCycleText(cycle) }}
              </v-chip>
            </div>
          </template>

          <template #item.allowed_packages="{ item }">
            <div class="d-flex flex-wrap gap-1">
              <v-chip
                v-for="pkg in item.allowed_packages"
                :key="pkg"
                small
                color="secondary"
                class="ma-1"
              >
                {{ getPackageText(pkg) }}
              </v-chip>
            </div>
          </template>

          <template #item.detail="{ item }">
            <detail-link :to="to(item)" />
          </template>
        </m-datatable>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "DiscountCodesList",
  props: {},
  data() {
    return {
      filters: {},
      url: "sobhanAdmin/discountCodes/",
      packageItems: [
        { text: "پایه", value: "TWO" },
        { text: "هوشمند", value: "THREE" },
        { text: "قدرتمند", value: "FOUR" },
        { text: "حقوق و دستمزد", value: "PAYROLL" },
      ],
      billingCycleItems: [
        { text: "ماهانه", value: "monthly" },
        { text: "سالانه", value: "yearly" },
        { text: "شش ماهه", value: "six_monthly" },
        { text: "دائمی", value: "permanent" },
      ],
    };
  },
  computed: {
    headers() {
      let headers = [
        {
          text: "کد",
          value: "code",
        },
        {
          text: "درصد تخفیف",
          value: "discount_percentage",
          type: "numeric",
        },
        {
          text: "حداکثر مبلغ تخفیف",
          value: "max_discount_amount",
          type: "numeric",
        },
        {
          text: "از تاریخ",
          value: "start_at",
          type: "date",
        },
        {
          text: "تا تاریخ",
          value: "expire_at",
          type: "date",
        },
        {
          text: "تعداد",
          value: "usage_limit",
          type: "numeric",
        },
        {
          text: "تعداد استفاده شده",
          value: "usage",
          type: "numeric",
        },
        {
          text: "بازه های قابل استفاده",
          value: "allowed_billing_cycles",
          sortable: false,
          filterable: false,
        },
        {
          text: "پکیج های قابل استفاده",
          value: "allowed_packages",
          sortable: false,
          filterable: false,
        },
        {
          text: "فعال",
          value: "is_active",
          type: "boolean",
        },
        {
          text: "جزئیات",
          value: "detail",
          sortable: false,
          filterable: false,
        },
      ];

      return headers;
    },
  },
  methods: {
    to(item) {
      return {
        name: "DiscountCodeForm",
        params: {
          id: item.id,
        },
      };
    },
    
    getBillingCycleText(value) {
      const item = this.billingCycleItems.find(item => item.value === value);
      return item ? item.text : value;
    },
    
    getPackageText(value) {
      const item = this.packageItems.find(item => item.value === value);
      return item ? item.text : value;
    }
  },
};
</script>

<style scoped lang="scss">
.gap-1 {
  gap: 4px;
}
</style>